import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { RegService } from '../../shared/Reg.Service';
import { User } from '../../shared/user.model';
import { Resp } from '../../shared/resp.model';
import { AppInsightsService } from 'src/app/shared/AppInsights.Service';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})
export class StepTwoComponent implements OnInit {
  constructor(private regService: RegService, private appInsightsService: AppInsightsService) { }
  public showPlaceholder: boolean;
  public message = '';
  public error: boolean;
  public show = false;
  public type: string;
  public selectedItem = '';
  public questionList = [];
  public answers: any = [];
  public default: any = [];
  public data: any;
  public q: any = [];
  public isLoading = false;
  public resp: Resp;
  public agreed = false;
  public validId = false;
  public validPwd = false;
  public agreement = false;
  public moreorless = false;
  public moreorlessStr = '...Read more';
  @Input() userId: string;
  public pwd = '';
  public pwdc = '';
  public temp: any;
  public inValidMsg = "User ID is not valid";
  @Input() email: string;
  @Output() emitter: EventEmitter<string> = new EventEmitter();
  public validate = true;
  public formFieldErrors: any = {
    userId: false,
    pwd: false,
    pwdc: false,
    invalidPwd: false,
    invalidPass: false,
    email: false,
    validEmail: false,
    q: [false, false, false],
    same: false,
    answers: [false, false, false],
    agreement: false,
	PwdMaxlenthExceed: false
  };

  @ViewChild('user') user: ElementRef;
  @ViewChild('pass') pass: ElementRef;
  @ViewChild('repass') repass: ElementRef;
  @ViewChild('em') em: ElementRef;
  @ViewChildren('ques') ques: QueryList<any>;
  @ViewChildren('anws') anws: QueryList<any>;
  @ViewChild('passInfo') passInfo: ElementRef;

  ngOnInit() {
  	window.scroll(0, 0);
    this.q[0] = 'Select #1';
    this.q[1] = 'Select #1';
    this.q[2] = 'Select #1';
    this.type = 'password'; // display as '*'
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Employee Registration UI Step Two");
    this.regService.getQuestion().subscribe(resp => {
      this.data = resp;
      if (this.data && this.data.questions) {
        this.questionList = this.data.questions;
      }
    });
    this.regService.getMail().subscribe(resp => {
      this.temp = resp;
      if (this.temp && this.temp.newEmail) {
        this.email = this.temp.newEmail;
      }
    });
  }

  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  toggleForm(event: FocusEvent, modelName, index) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateInputFields(modelName, index);
  }
  
  
  checkSeq(str){
    const seq = /123|345|456|678|890|111|222|333|444|555|666|777|888|999|000/;
    return seq.test(str);
  }
  
  validateOnKeyPress(model){
    if(model === 'userId'){
      if(!!this.userId && (this.formFieldErrors.userId || this.formFieldErrors.invalidUserId)){
        this.validateInputFields('userId', undefined);
      }
    } else if(model === 'pwd' || model === 'pwdc'){
	  if (this.pwd.length > 24) {
		this.formFieldErrors.PwdMaxlenthExceed = true;
		this.formFieldErrors.invalidPwd = false;
		this.pwd = this.pwd.slice(0,25);
	  } else {
		this.formFieldErrors.PwdMaxlenthExceed = false;
	  }	
      if(!!this.pwd && !!this.pwdc && this.pwd === this.pwdc){
        this.validateInputFields('pwdc', undefined);
      }
    }
  }
  

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }
  moreorlessFn() {
    this.moreorless = !this.moreorless;
    if (this.moreorless) {
      this.moreorlessStr = 'Read less';
    } else {
      this.moreorlessStr = '...Read more';
    }
  }
  emailCheck() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"*~]+(\.[^<>()\[\]\\.,;:\s@"*~]+)*)|(".+"))@((([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,10}))$/;
    if (!regex.test(this.email)) {
      return true;
    } else {
      return false;
    }
  }
  
  validatePassword(str) {
	const liElements = this.passInfo.nativeElement.children;
	let valid = true;
	for (let a=0;a< liElements.length;a++) {
		if (liElements[a].className.indexOf('invalid') !== -1) {
			valid = false;
			break;
		}
	}
	return valid;
  }

  accpetNumericOnly(e: KeyboardEvent) {
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter
      [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
      (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
      (e.keyCode === 86 && e.metaKey === true) || // Cmd+V (Mac)
      (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
      (e.keyCode >= 35 && e.keyCode <= 39) // Home, End, Left, Right
    ) {
      return;  // let it happen, don't do anything
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }

  validateID(str) {
    //remove numbers for validating 2 letters 
    const value = str.replace(new RegExp("[0-9]", "g"), "");
     
  	// Min 7 and Max 18 characters and 1 number and Min 2 letters and no special character
  	let isVal = false;
    if (str && str.length >= 7 && str.length <= 18 && str.match('.*\\d.*') && value.match('^[a-zA-Z]{2,}$')) {
      isVal = true;
    }
    if (!isVal) {
    	if(str.indexOf(" ") !== -1) {
    		this.inValidMsg = "User Name cannot contain a space";
    	} else {
    		this.inValidMsg = "User ID is not valid";
    	}
    }
    return isVal;
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formFieldErrors.userId || !!this.formFieldErrors.invalidUserId) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldErrors.pwd || !!this.formFieldErrors.invalidPwd) {
      setError = true;
      setTimeout(() => this.pass.nativeElement.focus(), 0);
      setTimeout(() => this.pass.nativeElement.select(), 0);
      window.scrollTo(0,this.pass.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldErrors.pwdc || !!this.formFieldErrors.invalidPass) {
      setError = true;
      setTimeout(() => this.repass.nativeElement.focus(), 0);
      setTimeout(() => this.repass.nativeElement.select(), 0);
      window.scrollTo(0,this.repass.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldErrors.email || !!this.formFieldErrors.validEmail) {
      setError = true;
      setTimeout(() => this.em.nativeElement.focus(), 0);
      setTimeout(() => this.em.nativeElement.select(), 0);
      window.scrollTo(0,this.em.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldErrors.q[0] || !!this.formFieldErrors.q[1] || !!this.formFieldErrors.q[2] || !!this.formFieldErrors.same) {
      for (let j = 0; j < this.ques.toArray().length; j++) {
        if (!!this.formFieldErrors.q[j]) {
          setError = true;
          setTimeout(() => this.ques.toArray()[j].nativeElement.focus(), 0);
          setTimeout(() => this.ques.toArray()[j].nativeElement.select(), 0);
          window.scrollTo(0,this.ques.toArray()[j].nativeElement.getBoundingClientRect().top + window.scrollY - 150);
          break;
        }
      }
    } else {
      for (let j = 0; j < this.anws.toArray().length; j++) {
        if (!!this.formFieldErrors.answers[j]) {
          setError = true;
          setTimeout(() => this.anws.toArray()[j].nativeElement.focus(), 0);
          setTimeout(() => this.anws.toArray()[j].nativeElement.select(), 0);
          window.scrollTo(0,this.anws.toArray()[j].nativeElement.getBoundingClientRect().top + window.scrollY - 150);
          break;
        }
      }
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.formFieldErrors.userId && !this.formFieldErrors.invalidUserId
      && !this.formFieldErrors.pwd && !this.formFieldErrors.invalidPwd
      && !this.formFieldErrors.pwdc && !this.formFieldErrors.invalidPass
      && !this.formFieldErrors.email && !this.formFieldErrors.validEmail
      && !this.formFieldErrors.q[0] && !this.formFieldErrors.q[1] && !this.formFieldErrors.q[2]
      && !this.formFieldErrors.answers[0] && !this.formFieldErrors.answers[1] && !this.formFieldErrors.answers[2]
      && !this.formFieldErrors.same
      && !this.formFieldErrors.agreement) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['userId', 'pwd', 'pwdc', 'email', 'q', 'answers', 'same', 'agreement'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      if (fields[j] === 'agreement') {
        if (!this.agreement) {
          isErrPresent = true;
          this.formFieldErrors.agreement = true;
          if (isErrPresent) {
            break;
          }
        }
      } else if (fields[j] !== 'answers' && fields[j] !== 'q') {
        isErrPresent = this.validateInputFields(fields[j], undefined);
        if (isErrPresent) {
          break;
        }
      } else {
        for (let k = 0; k < 3; k++) {
          isErrPresent = this.validateInputFields(fields[j], k);
          if (isErrPresent) {
            break;
          }
        }
        if (isErrPresent) {
          break;
        }
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  ifAtleastOneFieldValidatedIndex(model, index) {
    this.validate = !!this[model][index] ? false : true;
    return this.validate;
  }

  validateInputFields(model, index) {
    let error = false;
    this.validate = true;

    if (model === 'userId') {
      if (!this.userId || this.userId === undefined) {
        this.formFieldErrors.userId = true;
        this.formFieldErrors.invalidUserId = false;
        error = true;
      } else if (!this.validateID(this.userId)) {
        this.formFieldErrors.userId = false;
        this.formFieldErrors.invalidUserId = true;
        error = true;
      } else {
        this.formFieldErrors.userId = false;
        this.formFieldErrors.invalidUserId = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'pwd') {
      if (!this.pwd) {
        this.formFieldErrors.pwd = true;
        this.formFieldErrors.invalidPwd = false;
        error = true;
        return error;
      } else if (!this.validatePassword(this.pwd)) {
        this.formFieldErrors.invalidPwd = true;
        this.formFieldErrors.pwd = false;
        error = true;
      } else {
        this.formFieldErrors.pwd = false;
        this.formFieldErrors.invalidPwd = false;
        this.ifAtleastOneFieldValidated(model);
      }
      if(this.pwd.length>24){
		this.formFieldErrors.pwd = false;
		this.formFieldErrors.invalidPwd = false;
		this.formFieldErrors.PwdMaxlenthExceed = true;
		error = true;
	  }		
    }

    if (model === 'pwdc') {
      if (!this.pwdc) {
        this.formFieldErrors.pwdc = true;
        error = true;
      } else {
        this.formFieldErrors.pwdc = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'pwdc') {
      if (this.pwdc !== this.pwd) {
        error = true;
        this.formFieldErrors.pwdc = false;
        this.formFieldErrors.invalidPass = true;
      } else {
        this.formFieldErrors.invalidPass = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'email') {
      if (!this.email) {
        this.formFieldErrors.email = true;
        error = true;
      } else {
        this.formFieldErrors.email = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'email') {
      if (this.emailCheck()) {
        error = true;
        this.formFieldErrors.email = false;
        this.formFieldErrors.validEmail = true;
      } else {
        this.formFieldErrors.validEmail = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    if (model === 'q' && index === 0) {
      if (this.q[0] === 'Select #1') {
        this.formFieldErrors.q[0] = true;
        error = true;
      } else {
        this.formFieldErrors.q[0] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (model === 'q' && index === 1) {
      if (this.q[1] === 'Select #1') {
        this.formFieldErrors.q[1] = true;
        error = true;
      } else {
        this.formFieldErrors.q[1] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (model === 'q' && index === 2) {
      if (this.q[2] === 'Select #1') {
        this.formFieldErrors.q[2] = true;
        error = true;
      } else {
        this.formFieldErrors.q[2] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (model === 'same') {
      if (this.q[0] === this.q[1] ||
        this.q[1] === this.q[2] ||
        this.q[2] === this.q[0]) {
        const found = this.questionList.some(r => this.q.indexOf(r) >= 0);
        if (found) {
          error = true;
          this.formFieldErrors.same = true;
        } else {
          this.formFieldErrors.same = false;
          this.ifAtleastOneFieldValidated(model);
        }
      }
    }

    if (model === 'answers' && index === 0) {
      if (!this.answers[0]) {
        this.formFieldErrors.answers[0] = true;
        error = true;
      } else {
        this.formFieldErrors.answers[0] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
      this.validateInputFields('q', index);
    }

    if (model === 'answers' && index === 1) {
      if (!this.answers[1]) {
        this.formFieldErrors.answers[1] = true;
        error = true;
      } else {
        this.formFieldErrors.answers[1] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
      this.validateInputFields('q', index);
    }

    if (model === 'answers' && index === 2) {
      if (!this.answers[2]) {
        this.formFieldErrors.answers[2] = true;
        error = true;
      } else {
        this.formFieldErrors.answers[2] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
      this.validateInputFields('q', index);
    }

    if (model === 'agreement') {
      if (!this.agreement) {
        this.formFieldErrors.agreement = true;
        error = true;
      } else {
        this.formFieldErrors.agreement = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    console.log(this.formFieldErrors);
    if (!!this.userId && !!this.pwd && !!this.pwdc && !!this.email
      && this.q[0] !== 'Select #1' && this.q[1] !== 'Select #1' && this.q[2] !== 'Select #1'
      && !!this.answers[0] && !!this.answers[1] && !!this.answers[2] && !!this.agreement
      && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  checkData() {
    let valid = false;
    if (this.agreement) {
      valid = true;
    }
    return valid;
  }

  selected(value: any) {
    // console.log('selected dropdown: ' + value.target.name + value.target.value);
  }

  onSubmit() {
    this.error = false;
    if(!this.validateID(this.userId)){
      this.error = true;
      this.message = 'User IDs must have 7-18 characters, include at least one number, two letters, and no special characters. Please try again. [Error: 4005]';
      window.scrollTo(0, 0);
      return;
    }
    if(this.checkSeq(this.pwd) || !this.validatePassword(this.pwd)){
      this.error = true;
      this.message = 'Your new password must be 8 to 24 characters in length, must include an upper case letter, a lower case letter, a number and a special character (such as !,*,#,etc.), and may not include common terms (such as "password", "default", etc.), User ID, previous passwords or character strings (such as abc, 123, etc.).';
      window.scrollTo(0, 0);
      return;
    }
    if (!this.validateAllFields()) {
      setTimeout(() => {
        this.error = false;
        this.isLoading = true;
        this.message = '';
        this.validate = true;
      });
      const user = new User();
      user.uid = this.userId;
      user.userPassword = this.pwd;
      user.email = this.email;
      user.secretQuestion = this.q[0];
      user.secretQuestion2 = this.q[1];
      user.secretQuestion3 = this.q[2];
      user.secretQuestionAnswer = this.answers[0];
      user.secretQuestionAnswer2 = this.answers[1];
      user.secretQuestionAnswer3 = this.answers[2];

      const bodyString = JSON.stringify(user);
      console.log('json: ' + bodyString);
      this.regService.regStepTwo(bodyString).subscribe(res => {
        this.resp = res;
        if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {
          setTimeout(() => {
            this.isLoading = false;
          });
          if (this.resp.status_code === '200') {
            console.log('success');
            this.emitter.emit('three');
          } else {
            if (this.resp.message) {
              this.message = this.resp.message;
            } else {
              this.message = 'Session has expired please close browser and try again';
            }
            this.error = true;
            this.validate = false;
            window.scroll(0, 0);
          }
        }
      });
    } else {
      this.focusOnInput();
    }
  }

  goBack(){
    window.history.go(-2);
  }

}
